/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
import React from 'react';
import moment from 'moment';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Typography, IconButton } from '@material-ui/core';
import CustomToolbar from '../../common/CustomToolbar/CustomToolbar';

import _ from '../../../utils/lodash';
import globals from '../../../globals/communityGlobals';

const mapPropName = (columnName, isEntityToDto = false) => {
  const entityNames = ['Name', 'Clinicians', 'Unit', 'ValidFrom', 'ValidTo'];
  const dtoNames = ['name', 'clinicians', 'unit', 'validFrom', 'validTo'];
  if (isEntityToDto) {
    const index = _.indexOf(entityNames, columnName);
    return dtoNames[index];
  }
  const index = _.indexOf(dtoNames, columnName);
  return entityNames[index];
};

const setSortDirection = (columnDtoName, options) => {
  const entityName = mapPropName(columnDtoName, false);

  return entityName === options.sortColumn ? options.sortDirection : 'none';
};

const mapRowData = rowData => {
  const mappedRowData = [
    'id',
    'clinicianOptions',
    'orgUnitOption',
    'name',
    'clinicianNames',
    'orgUnitName',
    'validFrom',
    'validTo',
  ];
  const result = {};
  // eslint-disable-next-line no-return-assign
  mappedRowData.forEach((data, i) => {
    result[data] = rowData[i];
  });
  return result;
};

const editClinicianGroupSidePanel = (rowData, eventHandlers) => {
  eventHandlers.handleSidePanel(true, mapRowData(rowData));
};

const disableClinicianGroupWarning = (rowData, eventHandlers) => {
  eventHandlers.handleWarningPanel(true, mapRowData(rowData));
};

export const tableSettings = options => {
  const locale = options.eventHandlers.locale;
  const eventHandlers = options.eventHandlers;

  return {
    name: <Typography variant="h3">{locale.getMsg('clinicianGroups')}</Typography>,
    columns: [
      {
        name: 'id',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'clinicianOptions',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'orgUnitOption',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'name',
        label: locale.getMsg('name'),
        options: {
          sort: true,
          sortOrder: {
            name: 'name',
            direction: setSortDirection('name', options),
          },
        },
      },
      {
        name: 'clinicianNames',
        label: locale.getMsg('clinicians'),
        options: {
          sort: false,
        },
      },

      {
        name: 'orgUnitName',
        label: locale.getMsg('orgUnit'),
        options: {
          sort: false,
        },
      },
      {
        name: 'validFrom',
        label: locale.getMsg('dateFrom'),
        options: {
          sort: true,
          sortOrder: {
            name: 'validFrom',
            direction: setSortDirection('validFrom', options),
          },
          setCellProps: () => ({ style: { width: '150px' } }),
          customBodyRender: value => (value ? moment(value).format(globals.dateFormats.short) : '-'),
        },
      },
      {
        name: 'validTo', // value is mapped from initial valid to
        label: locale.getMsg('dateTo'),
        options: {
          sort: true,
          sortOrder: {
            name: 'validTo',
            direction: setSortDirection('validTo', options),
          },
          setCellProps: () => ({ style: { width: '150px' } }),
          customBodyRender: value => (value ? moment(value).format(globals.dateFormats.short) : '-'),
        },
      },
      {
        name: 'Actions',
        label: 'Actions',
        options: {
          display: options.activeOnly,
          sort: false,
          setCellHeaderProps: () => ({ className: 'centered' }),
          setCellProps: () => ({ style: { width: '150px' } }),
          customBodyRender: (value, tableMeta) => (
            <div>
              <IconButton onClick={() => editClinicianGroupSidePanel(tableMeta.rowData, eventHandlers)}>
                <EditIcon />
              </IconButton>
              |
              <IconButton onClick={() => disableClinicianGroupWarning(tableMeta.rowData, eventHandlers)}>
                <DeleteIcon />
              </IconButton>
            </div>
          ),
        },
      },
    ],
    options: {
      filterType: 'dropdown',
      responsive: 'standard',
      selectableRows: 'none',
      rowsPerPageOptions: [5, 15, 30, 50, 100],
      rowsPerPage: options.pageSize,
      print: true,
      search: false,
      filter: false,
      serverSide: true,
      count: options.count,
      page: options.page,
      downloadOptions: {
        filename: 'clinicianGroups.csv',
        separator: ',',
        filterOptions: { useDisplayedColumnsOnly: true, useDisplayedRowsOnly: true },
      },
      customToolbar: () => (
        <CustomToolbar eventHandlers={options.eventHandlers} isTableDataLoading={options.isUpdateTriggered} />
      ),
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
          case 'changeRowsPerPage':
            options.eventHandlers.updateTableProps(tableState.page + 1, tableState.rowsPerPage);
            break;
          case 'sort':
            let sortColumn = '';
            let sortDirection = '';

            if (tableState.activeColumn > -1) {
              sortColumn = mapPropName(tableState.sortOrder.name);
              sortDirection = tableState.sortOrder.direction;
              options.eventHandlers.updateTableSort(sortColumn, sortDirection);
            }
            break;
        }
      },
    },
  };
};
